module.exports = __webpack_public_path__ + "img/26.ee1ef671.jpg";